<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Edit Default Checklist'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row [align]="'center'">
        @if (type === 'address' && action === 'edit') {
          <tidy-text
            [body]="'Editing the default list for address:'" />
          <tidy-text
            [body]="address?.viewValue" />
        }
        @if (type === 'address' && action === 'add') {
          <tidy-text
            [body]="'Adding the default list for address:'" />
          <tidy-text
            [body]="address?.viewValue" />
        }
        @if (type === 'account' && action === 'edit') {
          <tidy-text
            [body]="'Editing the default list for your account.'" />
        }
        @if (type === 'account' && action === 'add') {
          <tidy-text
            [body]="'Adding a default list for your account.'" />
        }
      </tidy-row>
      <tidy-card>
        <form [formGroup]="form">
          @if (type === 'account') {
            <tidy-row class="field-bottom-padding">
              <tidy-select
                [icon]="'assets/svg/information-circle-outline.svg'"
                [label]="'Service'"
                [form]="form.controls.service"
                formControlName="service"
                [items]="serviceItems" />
            </tidy-row>
          }
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/list.svg'"
              [label]="'Default List'"
              [form]="form.controls.defaultList"
              formControlName="defaultList"
              [items]="listItems" />
          </tidy-row>
          @if (listItems?.length == 0) {
            <tidy-row>
              <tidy-text
                [body]="'You haven\'t added any templates to make into account service defaults. Please go to the'" /><span>&nbsp;</span>
                <tidy-text
                  [actionBody]="'list settings'"
                  class="link"
                  (action)="goToListSettings()" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'page and make one of your lists a template to make it an account service default. The list cannot have rooms specific to an address to make it a template.'" />
                </tidy-row>
              }
              @if (listItems?.length !== 0) {
                <tidy-row>
                  <tidy-text
                    [body]="'Note: you can only make a template an account service default. Go to your'" /><span>&nbsp;</span>
                    <tidy-text
                      [actionBody]="'list settings'"
                      class="link"
                      (action)="goToListSettings()" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'page and make one of your lists a template to make it an account service default. The list cannot have rooms specific to an address to make it a template.'" />
                    </tidy-row>
                  }
                </form>
              </tidy-card>
              <tidy-button
                [text]="'Save'"
                [action]="boundSaveNewDefault"
                class="primary" />
              @if (errorMessage) {
                <tidy-error-message
                  [text]="errorMessage" />
              }
            }
          </tidy-wrapper>
        </ng-template>

        <app-scroll-wrapper [templateContent]="content" />
